import { OnMounted } from '@studyportals/vue-platform';
import { Ref, ref, watch, nextTick, computed } from 'vue';
import Score from '../../Score/Score';

export default class ScoreGradientCircle extends Score implements OnMounted {
	private startTimeout = 500;
	private animationSpeed = 2;
	private animationIntervalKey;

	private first50Circle: Ref<HTMLDivElement | null> = ref(null);
	private second50Circle: Ref<HTMLDivElement | null> = ref(null);

	public mounted(): void | Promise<void> {
		window.setTimeout(() => {
			this.startAnimation();
		}, this.startTimeout);

		watch(this.score, async () => {
			await nextTick(() => this.startAnimation());
		});
	}

	private startAnimation(): void {
		if (!this.first50Circle.value || !this.second50Circle.value) {
			return;
		}

		let currentScoreInDegree = 0;
		this.animationIntervalKey = window.setInterval(() => {
			this.animateGradient(currentScoreInDegree);
			currentScoreInDegree += this.animationSpeed;
		}, 1);
	}

	private animateGradient(currentScoreInDegree: number): void {
		if (
			!this.first50Circle.value ||
			!this.second50Circle.value ||
			!this.displayScore.value
		) {
			return;
		}

		if (currentScoreInDegree > this.displayScore.value.score * 3.6) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
			clearInterval(this.animationIntervalKey);
		}

		if (currentScoreInDegree <= 180) {
			this.first50Circle.value.style.transform = `rotate(${currentScoreInDegree}deg)`;
			return;
		}

		this.first50Circle.value.style.display = 'none';
		this.second50Circle.value.style.transform = `rotate(${currentScoreInDegree - 180}deg)`;
	}

	public scoreCircleStyle = computed(() => {
		if (!this.displayScore.value) {
			return '';
		}

		if (this.displayScore.value.score <= 30) {
			return 'Score-Red';
		}

		if (this.displayScore.value.score <= 70) {
			return 'Score-Yellow';
		}


		return 'Score-Green';
	});
}
